// src/pages/About/index.js
import React from "react";
import { Card, Typography } from "antd";

export default function About() {
  return (
    <Card className="themed-card" bodyStyle={{ padding: "22px 26px" }}>
      <Typography.Title level={3} style={{ color: "var(--text-primary)" }}>
        关于
      </Typography.Title>
      <Typography.Paragraph style={{ color: "var(--text-primary)" }}>
        这是一个按你当前目录结构实现的 React + Ant Design 博客前端：
        包含登录、写文章、详情页、归档页。
      </Typography.Paragraph>
      <Typography.Paragraph
        type="secondary"
        style={{ color: "var(--text-secondary)" }}
      >
        当前数据保存在 localStorage。后续接后端只需要替换 src/api/mockData.js 的实现即可。
      </Typography.Paragraph>
    </Card>
  );
}
